import React from 'react';
import CountUp from 'react-countup';

function KpiCard({ title, value, subtitle, icon, iconColour, children }) {
  return (
    <div className="h-full bg-white rounded-xl border border-gray-200 shadow-sm p-5 flex items-start justify-between gap-3">
      <div className="min-w-0 space-y-1">
        <p className="text-xs font-medium uppercase tracking-wide text-gray-500">
          {title}
        </p>
        <CountUp
          duration={1}
          separator=","
          end={value ?? 0}
          className="block text-3xl font-semibold text-gray-900 tabular-nums"
        />
        {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
        {children}
      </div>
      {icon && (
        <div
          className="h-11 w-11 shrink-0 rounded-full flex items-center justify-center text-white text-2xl"
          style={{ backgroundColor: iconColour }}
        >
          {icon}
        </div>
      )}
    </div>
  );
}

export default KpiCard;
